<div class="status__wrapper">
  <ng-container *ngIf="event$ | async as event">
    <form [formGroup]="form">
      <app-status-control [event]="event" formControlName="status"></app-status-control>
    </form>
  </ng-container>
</div>
